import React, { useEffect, useState } from 'react';
import axios from 'axios';

export default function AccountPage({ C, STYLES, API }) {
  const [users, setUsers] = useState([]);
  const [modal, setModal] = useState(null);
  const [form, setForm] = useState({ username: '', password: '' });
  const [err, setErr] = useState('');
  const [showPass, setShowPass] = useState({});

  const load = () => axios.get(`${API}/api/users`).then((response) => setUsers(response.data)).catch(() => { });

  useEffect(() => {
    load();
  }, []);

  const openAdd = () => {
    setForm({ username: '', password: '' });
    setErr('');
    setModal({ mode: 'add' });
  };

  const openEdit = (user) => {
    setForm({ username: user.username, password: user.password });
    setErr('');
    setModal({ mode: 'edit', user });
  };

  const closeModal = () => setModal(null);

  const save = async () => {
    setErr('');
    try {
      if (modal.mode === 'add') {
        await axios.post(`${API}/api/users`, form);
      } else {
        await axios.put(`${API}/api/users/${modal.user.id}`, form);
      }
      await load();
      closeModal();
    } catch (error) {
      setErr(error.response?.data?.error || 'An error occurred');
    }
  };

  const del = async (id) => {
    if (!window.confirm('Delete this user?')) return;
    await axios.delete(`${API}/api/users/${id}`).catch(() => { });
    load();
  };

  const togglePass = (id) => setShowPass((prev) => ({ ...prev, [id]: !prev[id] }));

  return (
    <div style={STYLES.accountWrap}>
      <div style={STYLES.accountTitle}>👤 Admin</div>
      <div style={STYLES.accountSub}>Manage SMTP users — these credentials are used to authenticate email sending.</div>

      <button id="add-user-btn" style={STYLES.addBtn} onClick={openAdd}>＋ Add User</button>

      <div style={STYLES.tableWrap}>
        <table style={STYLES.table}>
          <thead>
            <tr>
              {['ID', 'Full Name', 'Username', 'Plan', 'Password', 'Actions'].map((heading) => <th key={heading} style={STYLES.th}>{heading}</th>)}
            </tr>
          </thead>
          <tbody>
            {users.length === 0 ? (
              <tr><td colSpan={6} style={{ ...STYLES.td, textAlign: 'center', color: C.muted, padding: 32 }}>No users yet — click "Add User" to create one.</td></tr>
            ) : users.map((user) => (
              <tr key={user.id} className="trow">
                <td style={{ ...STYLES.td, ...STYLES.tdId }}>#{user.id}</td>
                <td style={STYLES.td}>{user.full_name || '—'}</td>
                <td style={{ ...STYLES.td, ...STYLES.tdUser }}>{user.username}</td>
                <td style={STYLES.td}>{user.plan_name || '—'}</td>
                <td style={STYLES.td}>
                  <span style={STYLES.tdPass}>{showPass[user.id] ? user.password : '••••••••'}</span>
                  <button onClick={() => togglePass(user.id)} style={{ marginLeft: 8, fontSize: 11, background: 'none', border: 'none', color: C.muted, cursor: 'pointer' }}>
                    {showPass[user.id] ? '🙈' : '👁'}
                  </button>
                </td>
                <td style={STYLES.td}>
                  <button style={STYLES.editBtn} onClick={() => openEdit(user)}>Edit</button>
                  <button style={STYLES.delBtn} onClick={() => del(user.id)}>Delete</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {modal && (
        <div style={STYLES.overlay} onClick={(event) => event.target === event.currentTarget && closeModal()}>
          <div style={STYLES.modal}>
            <div style={STYLES.modalTitle}>{modal.mode === 'add' ? '➕ Add User' : '✏️ Edit User'}</div>
            {err && <div style={STYLES.errMsg}>{err}</div>}
            <label style={STYLES.label}>Username</label>
            <input id="user-username" style={STYLES.input} className="modal-input" value={form.username} onChange={(event) => setForm((prev) => ({ ...prev, username: event.target.value }))} placeholder="e.g. john@example.com" autoFocus />
            <label style={STYLES.label}>Password</label>
            <input id="user-password" style={STYLES.input} className="modal-input" type="text" value={form.password} onChange={(event) => setForm((prev) => ({ ...prev, password: event.target.value }))} placeholder="plain-text password" />
            <div style={STYLES.modalActions}>
              <button style={STYLES.cancelBtn} onClick={closeModal}>Cancel</button>
              <button id="save-user-btn" style={STYLES.saveBtn} onClick={save}>
                {modal.mode === 'add' ? 'Create' : 'Save'}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}